import Checkbox from 'src/components/checkbox/Checkbox';
import Modal from 'src/components/modal/Modal';
import infoIcon from 'src/icons/info.svg';

const SecurityLevelCheckbox = ({ checked, setChecked, isModalOpen, setIsModalOpen }) => (
    <div className="flex items-center mt-4 mb-2">
        <label htmlFor="maximumSecurity" className="flex items-center mt-4 mb-4">
            <Checkbox fieldName="maximumSecurity" checked={checked} onChange={setChecked} className="mr-2" />
            Use maximum security level
        </label>
        <button onClick={() => setIsModalOpen(true)} className="ml-2" type="button">
            <img src={infoIcon} alt="security levels info" />
        </button>
        <Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen} title="Security levels information">
            <p>
                Payonix is safe and no one can ever access your information. Everything is encrypted in the database. If
                you choose the maximum security level, your data will use 2 levels of encryption
                <br />
                <br />
                If you choose to use the maximum security level,&nbsp;
                <b className="underline">
                    you will have to re-enter your password to confirm every billing for subscription payments.
                </b>
                <br />
                <br />
                If you{' '}
                <b className="underline">
                    don't choose the maximum security level, you won't have to confirm subscription payments for every
                    new billing
                </b>
                , only the first one.
            </p>
        </Modal>
    </div>
);

export default SecurityLevelCheckbox;
